import { Action, ActionReducer, createReducer, on } from '@ngrx/store';

import { UsersActions } from './users.actions';
import { UsersState } from './users.state';

export const initUserState: UsersState = {
  links: [],
  users: [],
  loading: false,
  loaded: false,
  error: null,
  searchParams: {
    loginId: '',
    firstName: '',
    familyName: '',
    city: '',
    street: '',
    postalCode: '',
    limit: undefined,
    offset: undefined,
    companyNumber: '',
  },
};

export const usersListReducer: ActionReducer<UsersState, Action> = createReducer(
  initUserState,
  on(
    UsersActions.listUsersSearchResult,
    (_state, { searchParams }): UsersState => ({
      ...initUserState,
      loading: true,
      loaded: false,
      searchParams,
    })
  ),

  on(
    UsersActions.listUsersSearchResultSuccess,
    (state, { payload }): UsersState => ({
      ...state,
      links: payload._links,
      users: payload.users,
      loading: false,
      loaded: true,
    })
  ),

  on(
    UsersActions.listUsersSearchResultError,
    (state): UsersState => ({
      ...state,
      loading: false,
      loaded: true,
    })
  ),

  on(
    UsersActions.listCompanyUsersSearchResult,
    (state, { companyNumber }): UsersState => ({
      ...initUserState,
      loading: true,
      loaded: false,
      searchParams: { ...state.searchParams, companyNumber },
    })
  ),

  on(
    UsersActions.listCompanyUsersSearchResultSuccess,
    (state, { payload }): UsersState => ({
      ...state,
      links: payload._links,
      users: payload.users,
      loading: false,
      loaded: true,
    })
  ),

  on(
    UsersActions.listCompanyUsersSearchResultError,
    (state): UsersState => ({ ...state, loading: false, loaded: true })
  ),

  on(
    UsersActions.listUsersSearchFetchMore,
    (state): UsersState => ({ ...state, loading: true, loaded: false })
  ),

  on(
    UsersActions.listUsersSearchFetchMoreSuccess,
    (state, { payload }): UsersState => ({
      ...state,
      links: payload._links,
      users: payload.users ? [].concat(state.users, payload.users) : state.users,
      loading: false,
      loaded: true,
    })
  ),

  on(
    UsersActions.listUsersSearchFetchMoreError,
    (state): UsersState => ({
      ...state,
      loading: false,
      loaded: true,
    })
  )
);
